import ViewBotsList from "../components/wpbot/ViewBotsList"
import BotForm from "../components/wpbot/BotForm"
import ViewToolsList from "../components/wpbot/ViewToolsList"
import ViewBotContactsList from "../components/wpbot/ViewBotContactsList"
import ViewConversations from "../components/wpbot/ViewConversations"

/**
 * Módulos del front WPBOT. La key en minúsculas se valida por "includes"
 * contra los permisos VIEW del RBAC (wpbot.menu.sider.option.view.*):
 *   BOT_LIST      → wpbot.menu.sider.option.view.bot_list
 *   BOT_DETAIL    → wpbot.menu.sider.option.view.bot_detail
 *   TOOL_LIST     → wpbot.menu.sider.option.view.tool_list
 *   CONTACT_LIST  → wpbot.menu.sider.option.view.contact_list
 *   CHAT_LIST     → wpbot.menu.sider.option.view.chat_list
 *
 * BOT_CREATE no tiene permiso VIEW propio: la página valida contra
 * "bot_detail" (ver pages/bots/CreateBot.tsx).
 */
export const modules = {
  BotList: "BOT_LIST",
  BotCreate: "BOT_CREATE",
  BotDetail: "BOT_DETAIL",
  ToolList: "TOOL_LIST",
  ContactList: "CONTACT_LIST",
  ChatList: "CHAT_LIST",
} as const

export const contentPath = {
  [modules.BotList]: "/bots",
  [modules.BotCreate]: "/create-bot",
  [modules.BotDetail]: "/bot/:id",
  [modules.ToolList]: "/tools",
  [modules.ContactList]: "/contacts",
  [modules.ChatList]: "/chats",
} as const

export const contentLayout = {
  [modules.BotList]: ViewBotsList,
  [modules.BotCreate]: BotForm,
  [modules.BotDetail]: BotForm,
  [modules.ToolList]: ViewToolsList,
  [modules.ContactList]: ViewBotContactsList,
  [modules.ChatList]: ViewConversations,
} as const
